import React, { useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import "./PieChartAnalysis.css";
import { AmountCountAvg } from "../AmountCountAvg/AmountCountAvg";
import { Button , ArrowBigRight } from "../../../ui";


function formatAmount(value) {
  if (value === null || value === undefined) return "-";
  const abs = Math.abs(value);

  if (abs >= 1_000_000_000)
    return Math.floor((value / 1_000_000_000) * 10) / 10 + "B";
  if (abs >= 1_000_000) return Math.floor((value / 1_000_000) * 10) / 10 + "M";
  if (abs >= 1_000) return Math.floor((value / 1_000) * 10) / 10 + "k";
  return value.toString();
}

export const PieChartAnalysis = ({
  title,
  series,
  innerRadius = 60,
  height = 400,
  width = 200,
  centerValue,
  data,
  isAmount = false,
  hideLegend = false,
}) => {
  const displayCenter = isAmount ? formatAmount(centerValue) : centerValue;
  const [isAll, setIsAll] = useState(false);

  return (
    <div className="pie-chart-container">
      {title && <p>{title}</p>}
      {isAll ? (
        <AmountCountAvg data={data} />
      ) : (
        <>
          {Array.isArray(series) ? (
            <PieChart
              height={height}
              width={width}
              series={[
                {
                  data: series,
                  innerRadius: innerRadius,
                  outerRadius: 100,
                  paddingAngle: 5,
                  cornerRadius: 5,
                  startAngle: -45,
                },
              ]}
              slotProps={{
                legend: {
                  direction: "horizontal",
                  position: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                },
              }}
              hideLegend={hideLegend}
              skipAnimation={false}
            />
          ) : (
            <PieChart
              height={height}
              width={width}
              series={[
                {
                  data: series?.completedAmount,
                  innerRadius: innerRadius,
                  outerRadius: 100,
                  paddingAngle: 5,
                  cornerRadius: 5,
                  startAngle: -45,
                },
              ]}
              slotProps={{
                legend: {
                  direction: "horizontal",
                  position: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                },
              }}
              hideLegend={hideLegend}
              skipAnimation={false}
            />
          )}

          {displayCenter !== undefined && displayCenter !== null && (
            <div
              className="pie-center-value"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "1.9rem",
                fontWeight: "bold",
                pointerEvents: "none",
                textAlign: "center",
              }}
            >
              {displayCenter}
            </div>
          )}
        </>
      )}
      <div className="top-value-buttons">
        <Button
  type="button"
  variant={!isAll ? "primary" : "secondary"}
  appearance={!isAll ? "filled" : "soft"}
  size="sm"
  icon={<ArrowBigRight size={16} />}
  onClick={() => setIsAll((prev) => !prev)}
/>
      </div>
    </div>
  );
};
